import React from "react";

import { Steward } from "components/Common/TableStyle";

export const REFERENCE_SOURCES_DATA = () => [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
    fixed: "left",
    width: 150,
  },
  {
    dataIndex: "description",
    key: "description",
    title: "Description",
    render: text => <div className="whitespace-pre-line">{text}</div>,
    width: 200,
  },
  {
    dataIndex: "reference_source_type",
    key: "reference_source_type",
    title: "Type",
    render: text => <div className="whitespace-pre-line">{text}</div>,
    width: 150,
  },
  {
    title: "Drafter",
    key: "drafter",
    dataIndex: "drafter",
    render: text => <Steward name={text?.name} title={text?.role} />,
    width: 200,
  },
  {
    title: "Approver",
    key: "approver",
    dataIndex: "approver",
    render: text => <Steward name={text?.name} title={text?.role} />,
    width: 200,
  },
];

export const REFERENCE_SOURCES_ROWS_DATA = [
  {
    id: 1,
    name: "Enterprise Gender",
    description: "This is our enterprise naming standards for gender",
    type: "Enterprise",
    steward: "Steward",
  },
  {
    id: 2,
    name: "HR Gender",
    description: "This is our HR department naming standards for gender",
    type: "Department",
    steward: "Steward",
  },
];
